import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AuthenticationService as SDKAuthenticationService, User as SDKUser } from '@adeo/ngx-kozikaza-api';
import { catchError, finalize, map, share, tap } from 'rxjs/operators';
import { KzFormModule } from '../../../kz-ui/ui/form/kz-form.module';
import { KzModalModule } from '../../../kz-ui/ui/modal/kz-modal.module';
import {
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Observable, Subscription, throwError } from 'rxjs';
import { UserService as LegacyUserService } from '../../../shared/services/features';
import { RoutesService } from '../../../shared/services/routes/routes.service';
import { UserStoreService } from '../../../shared/services/state-management/user-store.service';
import { ToastrService } from '../../../shared/services/utilities/toastr.service';
import { AuthPopinService } from '../auth-popin.service';

@Component({
  selector: 'app-optin-remind',
  templateUrl: './optin-remind.component.html',
  styleUrls: ['./optin-remind.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'kz-optin-remind',
  },
  imports: [
    CommonModule,
    KzFormModule,
    KzModalModule,
    ReactiveFormsModule,
  ],
  providers: [],
})
export class OptinRemindComponent implements OnDestroy {
  private subscriptions: Array<Subscription> = [];

  isInKazaplan$: Observable<boolean> = this.routesService.routeDatas.pipe(
    map((data) => !!data.isKazaplanRoute),
    share(),
  );

  submitted = false;

  authenticatedUser: SDKUser;

  constructor(
    private readonly routesService: RoutesService,
    private readonly cdr: ChangeDetectorRef,
    private readonly sdkAuthenticationService: SDKAuthenticationService,
    private readonly toastr: ToastrService,
    private authPopinService: AuthPopinService,
    private readonly legacyUserService: LegacyUserService,
    public readonly userStoreService: UserStoreService,
  ) {
  }

  save(optin: boolean) {
    this.submitted = true;

    this.subscriptions.push(
      this.legacyUserService.update(this.userStoreService.user['@id'], {
        optInPartnerEmail: optin,
        smartPriceModalViewed: true,
      }).pipe(
        finalize(() => this.submitted = false),
        catchError((e) => {
          this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
          this.cdr.markForCheck();

          return throwError(e);
        }),
        tap(() => this.sdkAuthenticationService.updateMe()),
      ).subscribe(() => this.authPopinService.closePopinAndRedirect()),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.map((subscription) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
